var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2IssuesV3(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.59837 6.18213C4.69841 6.95748 7.70394 8.61032 9.1942 9.33982L6.36893 10.2317C5.88088 10.3858 5.60445 10.8974 5.85034 11.3462C6.02543 11.6659 6.24252 11.9645 6.45835 12.0788C6.88354 12.3039 8.68358 12.3308 9.94457 12.3099L11.9131 17.8391M4.59837 6.18213C4.47331 5.21294 5.01311 4.95086 5.49885 4.68051C5.71666 4.55928 6.22968 4.31322 7.16108 4.68051M4.59837 6.18213L7.16108 4.68051M17.9999 11L18.4999 8.5L18.827 6.8647C18.9391 6.30427 18.8612 5.72246 18.6056 5.21127L16.9999 2L14.728 7.37016L15.6034 5.24419C12.4457 3.4934 10.1634 5.24419 9.66316 5.43178C9.39395 5.53273 8.24644 5.1085 7.16108 4.68051",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.64465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74028 6.19324L1.05376 5.20801",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.64465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56639 11.654L3.05859 10.5547",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.64465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74079 8.37402H1.44216H1.16218",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.64465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1005,
    cy: 7.69422,
    r: 1.03992,
    fill: "#7A7670",
    style: (_ref6 = {
      fill: "#7A7670"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2IssuesV3);
export default __webpack_public_path__ + "static/media/customV2IssuesV3.d554e99f03d35053ff1c60c3db62123e.svg";
export { ForwardRef as ReactComponent };